<script setup>
import {computed, ref} from 'vue';
import Section from '@/components/Section.vue';
import TopNote from '@/components/TopNote.vue';
import { buttons } from './buttons';
import { effects } from './effects';
import EffectButton from '@/components/sections/Effect/EffectButton.vue';
import MoleculeTable from '@/components/Molecule/MoleculeTable.vue';
import {moleculeRows} from '@/data/molecule-rows';


const currentMolecule = ref(null);

const atSelect = (molecule) => {
    currentMolecule.value = molecule;
};

const allMolecules = computed(() => {
    const m = [];
    for (const row of moleculeRows) {
        m.push(...row);
    }
    return m;
});

const currentEffects = computed(() => {
    const moleculeIndex = allMolecules.value.findIndex((m) => m.label === currentMolecule.value?.label);
    return effects[moleculeIndex] || {};
});

const effectIndeces = computed(() => {
    const keys =  Object.keys(currentEffects.value);
    return keys.map(k => Number(k.substring(3)));
});

const currentButtons = computed(() => {
    return effectIndeces.value.map((i) => {
        return {
            button: buttons[i],
            labels: currentEffects.value['eff' + i] || [],
        };
    });
});
</script>

<template>
    <Section id="effects">
        <h1>
            Effects
        </h1>
        <h2>
            <span>
                Why are air pollutants a problem?
            </span>
        </h2>

        <div class="wrapper">
            <TopNote class="top-note-effects">
                Click on the air pollutants to see some of their effects on health and the environment.
            </TopNote>

            <MoleculeTable @select="atSelect" :molecules="moleculeRows" :current="currentMolecule" />

            <div class="main">
                <div class="layer">
                    <img src="effect/effects-base.png" alt="" />
                </div>
                <div class="layer">
                    <img src="effect/effects-cloud.png" alt="" />
                </div>
                <div class="layer">
                    <img src="effect/effects-clouds.png" alt="" />
                </div>
                <div class="layer">
                    <EffectButton v-for="(item) in currentButtons" :key="item.labels.join()" :button="item.button" :labels="item.labels" />
                </div>
            </div>
        </div>
    </Section>
</template>


<style lang="scss" scoped>
.top-note-effects {
    text-align: center;
}

.wrapper {
    position: relative;
}

.main {
    position: relative;
    height: 440px;

    .layer {
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>
